
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { BUDGET_OVERVIEW } from '../../config';

import { GenericDiv } from 'commonStyles';
import { formatCurrency } from 'UtilityComponents/Util';
import { BudgetOverviewItem } from '../../styles';

/**
 * Renders the budget overview summary items (optimized with useMemo)
 */
const BudgetOverviewItemComponent = () => {
    // Get budget summary stats from Redux
    const budgetStats = useSelector(
        (state) => state?.budgetManagement?.budgetStats || {}
    );

    // Memoize items to prevent unnecessary recalculation
    const overviewItems = useMemo(() => (
        BUDGET_OVERVIEW.map((item, idx) => (
            <BudgetOverviewItem key={item.title || idx}>
                {/* Title */}
                <GenericDiv fsize="14" f_weight="400" color="#4A4A4A">
                    {item.title}
                </GenericDiv>

                {/* Value */}
                <GenericDiv
                    as="h3"
                    as="h3"
                    fsize="16"
                    f_weight="900"
                    color="#000000"
                    padding="16px 0 4px"
                >
                    {formatCurrency(budgetStats?.data?.[item.key] || 0, true)}
                </GenericDiv>
            </BudgetOverviewItem>
        ))
    ), [budgetStats]);

    return <>{overviewItems}</>;
};

export default BudgetOverviewItemComponent;